export default __webpack_public_path__ + "static/media/neet.d859e1f8.png";